export function About() {
    return (
        <div className="row">
            <div className="col-10" id="contact_form_el">
                <div className="row">
                    <div className="col-12 text-left mb-3">
                        <h3 className="header">About HealthLevel</h3>
                        <h5 className="sub-header">
                            We are a unique company built with customer trust and an incredible
                            team.
                        </h5>
                    </div>
                    <div className="col-12 text-left mb-2">
                        <p>
                            HealthLevel assists healthcare systems lead business transformation with
                            data driven facts and insight. We solve problems for our customers
                            through the process of building intuitive and easy to use web based
                            software.
                        </p>
                    </div>
                    <div className="col-12 text-left mb-2">
                        <p>
                            Foundations™ from HealthLevel is a pioneering data analysis and
                            integration platform that provides proactive business intelligence
                            capability across data warehouses, clinical, financial and operational
                            applications.
                        </p>
                    </div>
                    <div className="col-12 text-left">
                        <h5 className="sub-header">
                            For more information please contact us at{' '}
                            <span>
                                <a href="http://www.healthlevel.com">our public website</a>
                            </span>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    )
}
